import request from '@/utils/request'

/**
 * 获取用户列表数据
 */
export const getUserManageList = async (data) => {
  return await request({
    url: '/sys/v1/user/page',
    method: 'GET',
    params: data
  })
}
/**
 * 新增普通用户
 */
export const addUser = async (data) => {
  return await request({
    url: '/sys/v1/user/add-user',
    method: 'POST',
    data
  })
}

/**
 * 修改普通用户
 * @param {*} data
 * @returns
 */
export const updateUserInfo = async (data) => {
  return await request({
    url: '/sys/v1/user/updateUserInfo',
    method: 'POST',
    data
  })
}

/**
 * 删除普通用户
 */
export const delUser = async (id) => {
  return await request({
    method: 'DELETE',
    url: `/sys/v1/user/${id}`
  })
}

/**
 * 获取指定用户角色
 */
export const userRoles = (id) => {
  return request({
    url: `/sys/v1/role/listByUserId/${id}`
  })
}

/**
 * 分用户分配角色
 */
export const updateRole = (id, roles) => {
  return request({
    url: '/sys/v1/role/user-role',
    method: 'POST',
    data: roles.map((item) => ({
      roleId: item.id,
      userId: id
    }))
  })
}

/**
 * 添加微信聊天用户
 */
export const addWxChat = (data) => {
  return request({
    url: '/sys/v1/user/add-wxChat',
    method: 'POST',
    data
  })
}

/**
 * 根据门诊id得到微信聊天用户
 */
export const getUserByTenantIdAndClinicId = (clinicIdOrTenantId, type = 3) => {
  return request({
    method: 'GET',
    url: `/sys/v1/user/getUser/${clinicIdOrTenantId}/${type}`
  })
}

/**
 * 修改个人用户消息
 */
export const updateUser = (data) => {
  return request({
    method: 'PUT',
    url: '/sys/v1/user',
    data
  })
}

/**
 * 修改个人用户消息
 */
export const updateTenantUser = (data) => {
  return request({
    method: 'POST',
    url: '/sys/v1/user/updateUserInfo',
    data
  })
}

/**
 * 添加租户用户
 * @param { object } data {username: 账号, password: 密码, tenantId: 租户id,lastLoginClinic?:门诊id  }
 * @returns
 */
export const addTenantUser = (data) => {
  return request({
    method: 'POST',
    url: '/sys/v1/user/add-tenantManager',
    data
  })
}

/**
 * 添加诊所用户
 * @param {*} clinicId
 * @returns
 */
export const addClinicUser = (data) => {
  return request({
    method: 'POST',
    url: '/sys/v1/user/add-clinicManager',
    data
  })
}

/**
 * 查询审批人配置分页
 * @param {*} data
 * @returns
 */
export const getUserApprovalList = async (data) => {
  return request({
    url: '/sys/v1/approvalAuditor/findApprovalAuditorPage',
    method: 'GET',
    params: data
  })
}

/**
 * 新增审批人用户
 * @param {*} data
 * @returns
 */
export const addUserApproval = (data) => {
  return request({
    url: '/sys/v1/approvalAuditor/insertapprovalAuditor',
    method: 'POST',
    data
  })
}

/**
 * 修改审批人用户
 * @param {*} data
 * @returns
 */
export const updateUserApproval = (data) => {
  return request({
    url: '/sys/v1/approvalAuditor/updateApprovalAuditor',
    method: 'POST',
    data
  })
}

/**
 * 删除审批人用户
 * @param {*} id
 * @returns
 */
export const delUserApproval = (id) => {
  return request({
    url: `/sys/v1/approvalAuditor/deleteApprovalAuditor/${id}`,
    method: 'DELETE'
  })
}

/**
 * 查询所有权限菜单(B)
 * @returns
 */
export const getPermissionMenuList = () => {
  return request({
    url: '/sys/v1/hisMenu/findAllMenu'
  })
}

/**
 * 查询所有权限菜单(A)
 * @returns
 */
export const getPermissionMenu = () => {
  return request({
    url: '/sys/v1/menu/findAllMenu'
  })
}

/**
 * 根据角色查询菜单权限
 * @param {*} roleId
 * @returns
 */
export const getPermissionMenuListByRole = (roleId) => {
  return request({
    url: `/sys/v1/menu/role-id/${roleId}`
  })
}

export const rolePermissionMenu = (data) => {
  return request({
    method: 'POST',
    url: '/sys/v1/role/role-menu',
    data
  })
}
